import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSalesForce } from 'services/api/requests/salesForce';

import { mapErrorToToastProps } from '../../../utils/forms/mapErrorToToastProps';

export const useEditSalesForce = (id, body, onClose) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(() => updateSalesForce(id, body), {
		onSuccess: () => {
			queryClient.invalidateQueries(['forcaVenda-list']);
			queryClient.invalidateQueries(['forcaVendaById', id]);
			queryClient.invalidateQueries(['forcaVendaWithId', id]);

			toast({
				title: 'Atualizada com sucesso!',
				description: 'Força de venda atualizada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});

			onClose?.();
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao editar Força de venda!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
